import { RESET_STATE } from 'store/global/actions';

import { CHANGE_REQUEST_ACTION_TYPE } from '../actions';

const initialState = {
  pending: { data: [], isLoading: false, hasError: false },
  history: { data: [], isLoading: false, hasError: false },
  decision: { isSaving: false, errorMessage: null },
};

const changeRequestReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANGE_REQUEST_ACTION_TYPE.SET_PENDING_LOADING:
      return {
        ...state,
        pending: {
          ...state.pending,
          isLoading: payload,
          hasError: payload ? false : state.pending.hasError,
        },
      };

    case CHANGE_REQUEST_ACTION_TYPE.SET_PENDING_ERROR:
      return { ...state, pending: { ...state.pending, isLoading: false, hasError: true } };

    case CHANGE_REQUEST_ACTION_TYPE.GET_PENDING_CHANGE_REQUESTS:
      return { ...state, pending: { data: payload ?? [], isLoading: false, hasError: false } };

    case CHANGE_REQUEST_ACTION_TYPE.SET_HISTORY_LOADING:
      return {
        ...state,
        history: {
          ...state.history,
          isLoading: payload,
          hasError: payload ? false : state.history.hasError,
        },
      };

    case CHANGE_REQUEST_ACTION_TYPE.SET_HISTORY_ERROR:
      return { ...state, history: { ...state.history, isLoading: false, hasError: true } };

    case CHANGE_REQUEST_ACTION_TYPE.GET_CHANGE_REQUEST_HISTORY:
      return { ...state, history: { data: payload ?? [], isLoading: false, hasError: false } };

    case CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_SAVING:
      return { ...state, decision: { isSaving: payload, errorMessage: null } };

    case CHANGE_REQUEST_ACTION_TYPE.SET_DECISION_ERROR:
      return { ...state, decision: { isSaving: false, errorMessage: payload ?? null } };

    case CHANGE_REQUEST_ACTION_TYPE.CLEAR_DECISION_ERROR:
      return { ...state, decision: { ...state.decision, errorMessage: null } };

    // A decided (Approved/Rejected) request leaves the pending queue.
    case CHANGE_REQUEST_ACTION_TYPE.RESOLVE_CHANGE_REQUEST:
      return {
        ...state,
        pending: {
          ...state.pending,
          data: state.pending.data.filter(
            item => item.marginChangeRequestId !== payload.marginChangeRequestId,
          ),
        },
        decision: { isSaving: false, errorMessage: null },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default changeRequestReducer;
